// removed by extract-text-webpack-plugin
module.exports = {"text800":"_1jmTGeWPWfDT_jcEl_kstr","text700":"_12I4KzDpzv_YNu8j8H3v8w","text600":"_3FTKbRBRVt5eDGVuty_X2e","text500":"_3McjQWndV7_sROJ64oHa2K","text400":"_3qS5pRsZoCQaYT---JPkuF","text300":"_11bP1AJ1uf3_9OHuRdUtYS","text200":"JvisHTV0ZI4Kt0fzhvARz","textParagraph":"_1Z6wKX62ULA3bg6lCoRAG_","crimp":"_1neJ4HZn0o80TcZ21ohqED","trim":"_3m-A-j3selmtcgljwmtEJz","flexCenter":"_3clzlU9Qk1elg_yVuy5MhY","wrapper":"_1VJSmyzV5JbRYFjoZ184__","waiting":"_1STP85OdfWUYow7ignIZG4","hideTextOverflow":"_3yEJCXst42495JLaui9Zcg","marginPageMainContent":"Xe8EuyBCppcY4rkGpFsoS","disabled":"_2SKVKfyTQb4-4WK5HBUi7P"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/utilities/ButtonAction.scss
// module id = 720
// module chunks = 0